import client from '@libs/HttpClient';
class LoggedHoursPublicReport {
  static listReport({ fromDate, toDate, projectId, sprintId, selectedType, searchText }) {
    return client.get(
      `/report/public/logged-hours-report?from_date=${fromDate}&to_date=${toDate}&project_id=${projectId}&sprint_id=${sprintId}&selected_type=${selectedType}&search_text=${searchText}`
    );
  } 
  static projectListReport(request) {
    return client.get(
      `/report/public/all-projects`,
      request
    );
  }
  static sprintListReport(request) {
    return client.get(
      `/report/public/all-sprints/${request.project_id}`,
      request
    );
  }
}
export { LoggedHoursPublicReport };
